import Icon from 'veui/components/Icon'
import { IconUnderline } from 'dls-icons-vue'

Icon.register('underline', IconUnderline)
